<template>
    <div class="user_core">
        <Header :title="title"></Header>
        <van-row class="info_body">
            <van-col span="24" class="info_s">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                        <van-list
                                v-model="loading"
                                :finished="finished"
                                :finished-text="$t('financial.noMore')"
                                @load="onLoad"
                        >
                            <van-cell v-for="(item,index) in list" :key="index" >
                                <van-row class="list">
                                    <van-col span="4" class="list_ico">
                                        <van-icon :name="item.status ? 'star':'lock'" />
                                    </van-col>
                                    <van-col span="20" class="list_info">
                                        <van-row class="list_flin">
                                            <van-col span="16" class="list_title">{{item.title}}</van-col>
                                            <van-col span="8" class="list_val">{{item.amount}}</van-col>
                                        </van-row>
                                        <van-row class="list_slin">
                                            <van-col span="16" class="list_tiem">{{item.create_time}}</van-col>
                                            <van-col span="8" class="list_acount">{{item.earn}}</van-col>
                                        </van-row>
                                    </van-col>
                                </van-row>
                            </van-cell>
                        </van-list>
                </van-pull-refresh>

            </van-col>
        </van-row>
        <Footer></Footer>
    </div>
</template>


<script>
    import Header from '@/components/Header.vue'
    import Footer from '@/components/Footer.vue'
    export default {
        name: "My_investment",
        data(){
            return{
                title:this.$t('my_investment.pagetitle'),
                list: [],
                loading: false,
                finished: false,
                refreshing: false,
                page : 0,
                page_size: 10,
            }
        },
        components:{
            Header,
            Footer
        },
        methods: {
           async onLoad() {
                    if (this.refreshing) {
                        this.list = [];
                        this.refreshing = false;
                    }

                    let res = await this.getProjectlist(this.page,this.page_size);
                    // if(res.length <1){
                    //     this.list = JSON.parse(localStorage.getItem("proList"));
                    // }
                   //合并数组
                   this.list= this.list.concat(res);
                    this.loading = false;
                     this.page++;
                   if(res.length < this.page_size){
                       this.finished = true;
                   }
            },
            getProjectlist(page,page_size,){
                let pages = {'page':page,'page_size':page_size};
                return new Promise((resolve, reject) => {
                    this.getReq('/getProjectlist', pages).then(
                        (res) => {
                            if (res.code == 200) {
                                resolve(res.data) ;

                            }
                        })
                })
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;
               // localStorage.setItem('proList', JSON.stringify(this.list));
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.onLoad();
            },
        },
    }
</script>

<style scoped lang="scss">
    .user_core{
        min-height: 650px;
        background: url("~@/assets/images/bg_header.png") no-repeat center 45px;
        background-size: 100% ;
        .info_body{
            width: 92%;
            min-height: 500px ;
            margin: 18px auto 0 auto;
            border-radius: 10px;
            background: white;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
            .info_s {
                margin: 10px auto 40px auto;

                .list {
                    .list_ico {
                        font-size: 20px;
                        text-align: center;
                        color: #ff9900;
                        margin: 0 auto;
                    }

                    .list_info {
                        font-size: 14px;
                        color: #666666;

                        .list_flin {
                            .list_title {
                                font-weight: bold;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }

                            .list_val {
                                color: #f00;
                                text-align: right;
                            }
                        }

                        .list_slin {
                            color: #cccccc;
                            .list_acount{
                                text-align: right;
                            }
                        }

                    }
                }
            }
        }
    }
</style>
